import DefaultModal from "components/modal/default";
import "./serviceNotice.scss";

const ServiceNotice = () => {
  return (
    <DefaultModal
      isOpen={true}
      btnTxt={""}
      closeBtn={false}
      styles="max-w-[640px] p-8 -top-24"
      handleClose={() => {}}
    >
      <div className="notice-wrapper text-sm md:text-base">
        <h2 className="text-red-300 mb-5 text-xl md:text-2xl">
          📢 서비스 일시 중단 안내 (시스템 작업)
        </h2>
        <p className="">
          안녕하세요,&nbsp;
          <strong className="text-blue-300 font-font-B">MUSEUM</strong> 입니다.
        </p>

        <p>
          시스템 작업으로 인해 아래와 같이 서비스 이용이 일시적으로 중단됩니다.
        </p>

        <ul className="">
          <li className="font-font-B flex">
            <strong className="">중단 일시:</strong>&nbsp;
            <p className="text-red-300">
              &nbsp;2025년 8월 27일(수) 00:00 ~ 24:00 (하루 종일)
            </p>
          </li>
          <li>
            <strong className="font-font-B">중단 사유:</strong>&nbsp;서비스 작업
          </li>
          <li>
            <strong className="font-font-B">영향 범위:</strong>&nbsp;웹사이트 및
            관련 서비스 전체
          </li>
        </ul>

        <p>
          서비스 이용에 불편을 드려 대단히 죄송합니다.
          <br /> 감사합니다.
        </p>

        <p className="font-font-B">[유비컴퍼니 드림]</p>
      </div>
    </DefaultModal>
  );
};

export default ServiceNotice;
